export const primaryColor: string = "#008aff";
export const secondaryColor: string = "#ff0020";
export const lightBlue: string = "#e6f5ff";
